import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { CHANNELS_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';

export const COMMENTS_QUERY_KEY = 'comments';

export const useFetchCommentCount = ({
  channelId,
  deeplink,
  enabled = true,
}: FetchParams) => {
  return useQuery(
    [COMMENTS_QUERY_KEY, channelId, deeplink, 'count'],
    async ({ signal }) => {
      const { data } = await axiosInstance.get<Response>(
        CHANNELS_API_ROUTES.deeplinkCommentsCount(channelId, deeplink),
        { signal }
      );

      return data?.results;
    },
    {
      enabled: !!channelId && !!deeplink && enabled,
    }
  );
};

export const useInvalidateFetchCommentCount = () => {
  const queryClient = useQueryClient();

  return React.useCallback(
    ({ channelId, deeplink }: Pick<FetchParams, 'channelId' | 'deeplink'>) => {
      queryClient.invalidateQueries([
        COMMENTS_QUERY_KEY,
        channelId,
        deeplink,
        'count',
      ]);
    },
    [queryClient]
  );
};

export type Response = {
  results: Count;
};

type Count = {
  count: number;
};

type FetchParams = {
  channelId: string;
  deeplink: string;
  enabled?: boolean;
};
